var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckExito(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Check_exito",
    "data-name": "Check exito",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_107",
    "data-name": "Rect\\xE1ngulo 107",
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check_circle_FILL0_wght300_GRAD0_opsz40",
    d: "M107.621-848.745l-2.336-2.342a.613.613,0,0,0-.43-.176.591.591,0,0,0-.443.185.59.59,0,0,0-.18.432.589.589,0,0,0,.18.432l2.69,2.7a.7.7,0,0,0,.519.228.7.7,0,0,0,.519-.228l5.421-5.415a.629.629,0,0,0,.186-.44.591.591,0,0,0-.186-.443.61.61,0,0,0-.446-.175.612.612,0,0,0-.437.185ZM109-842a8.723,8.723,0,0,1-3.5-.709,9.132,9.132,0,0,1-2.863-1.931,9.126,9.126,0,0,1-1.932-2.862A8.713,8.713,0,0,1,100-851a8.768,8.768,0,0,1,.709-3.51,9.026,9.026,0,0,1,1.931-2.858,9.194,9.194,0,0,1,2.862-1.924A8.714,8.714,0,0,1,109-860a8.766,8.766,0,0,1,3.51.709,9.092,9.092,0,0,1,2.858,1.923,9.086,9.086,0,0,1,1.924,2.857A8.758,8.758,0,0,1,118-851a8.722,8.722,0,0,1-.709,3.5,9.2,9.2,0,0,1-1.923,2.863,9.021,9.021,0,0,1-2.857,1.932A8.758,8.758,0,0,1,109-842Zm0-1.19a7.527,7.527,0,0,0,5.537-2.278A7.539,7.539,0,0,0,116.811-851a7.535,7.535,0,0,0-2.273-5.537A7.535,7.535,0,0,0,109-858.809a7.54,7.54,0,0,0-5.532,2.273A7.526,7.526,0,0,0,101.191-851a7.531,7.531,0,0,0,2.278,5.532A7.531,7.531,0,0,0,109-843.189ZM109-851Z",
    transform: "translate(-96.002 863.998)",
    fill: "#0bce63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckExito);
export default __webpack_public_path__ + "static/media/check-exito.a2e5ee713e96068716a061e3a34e7e26.svg";
export { ForwardRef as ReactComponent };